import { useState, useEffect, useRef, useCallback } from 'react'
import { useAuth } from './useAuth'
import api from '../services/api'

/**
 * useChatUnread — polls the total unread chat count across all the user's
 * projects, for the red badge on the header chat icon. Polls every 15s.
 */
export function useChatUnread() {
  const { user, isAuthenticated } = useAuth()
  const [unread, setUnread] = useState(0)
  const intervalRef = useRef(null)

  const canChat = ['Admin', 'Project Manager', 'Consultant'].includes(user?.role)

  const fetchUnread = useCallback(async () => {
    if (!isAuthenticated || !canChat) return
    try {
      const r = await api.get('/chat/unread-total')
      setUnread(r.data?.unread || 0)
    } catch {
      // non-fatal
    }
  }, [isAuthenticated, canChat])

  useEffect(() => {
    if (!isAuthenticated || !canChat) { setUnread(0); return }
    fetchUnread()
    intervalRef.current = setInterval(fetchUnread, 15000)
    return () => clearInterval(intervalRef.current)
  }, [isAuthenticated, canChat, fetchUnread])

  return { unread, refresh: fetchUnread }
}
